import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Redirect, useLocation } from 'react-router-dom';
import InvestorQualification from '../InvestorQualification';

const InvestmentAccreditation = (props) => {
  const {
    nextPage, isAccredited, pageNumber, routesLength,
  } = props;
  const { search } = useLocation();
  return isAccredited ? <Redirect to={`${nextPage}${search}`} />
    : <InvestorQualification pageNumber={pageNumber} routesLength={routesLength} />;
};

InvestmentAccreditation.defaultProps = {
  isAccredited: false,
  pageNumber: 0,
  nextPage: '',
};

InvestmentAccreditation.propTypes = {
  isAccredited: PropTypes.bool,
  pageNumber: PropTypes.number,
  nextPage: PropTypes.string,
  routesLength: PropTypes.number.isRequired,
};

const mapStateToProps = ({ auth }) => ({
  isAccredited: auth.user && auth.user.isAccredited,
});

export default connect(mapStateToProps, null)(InvestmentAccreditation);
